import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { useAuthStore } from "../store/auth";
import { tenantApi, setupTasksApi } from "../lib/tenant";

export function DashboardPage() {
  const user = useAuthStore((s) => s.user);
  const { data: tenant } = useQuery({ queryKey: ["tenant"], queryFn: () => tenantApi.getMe() });
  const { data: tasks } = useQuery({
    queryKey: ["setup-tasks"],
    queryFn: () => setupTasksApi.list(),
  });

  const firstName = user?.name?.split(" ")[0] ?? "there";
  const openTasks = (tasks?.tasks ?? []).filter((t) => !t.completed_at);

  return (
    <>
      <div className="stage-header">
        <div>
          <div className="stage-eyebrow">Dashboard</div>
          <h1 className="stage-title">
            Welcome back, <em>{firstName}.</em>
          </h1>
          <p className="stage-sub">
            Cash, receivables, payables, compliance — at a glance. Pick up where you left off.
          </p>
        </div>
        <div className="stage-meta">
          {tenant && <span>Plan · {tenant.plan}</span>}
        </div>
      </div>

      <div className="hero-grid">
        <div className="hero-tile featured">
          <div className="hero-label">Cash position</div>
          <div className="hero-num">
            <span className="currency">Rs</span>—
          </div>
          <div className="hero-sub">Connect a bank to populate</div>
        </div>
        <div className="hero-tile">
          <div className="hero-label">To collect</div>
          <div className="hero-num">
            <span className="currency">Rs</span>—
          </div>
          <div className="hero-sub">Outstanding receivables</div>
        </div>
        <div className="hero-tile">
          <div className="hero-label">To pay</div>
          <div className="hero-num">
            <span className="currency">Rs</span>—
          </div>
          <div className="hero-sub">Bills due</div>
        </div>
        <div className="hero-tile">
          <div className="hero-label">Compliance</div>
          <div className="hero-num" style={{ fontSize: 22 }}>
            On track
          </div>
          <div className="hero-sub">No filings due in next 14 days</div>
        </div>
      </div>

      {openTasks.length > 0 && (
        <div className="card" style={{ marginBottom: 20 }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
            <div>
              <div className="stage-eyebrow">Setup tasks</div>
              <div style={{ fontFamily: "'Fraunces', serif", fontWeight: 500, fontSize: 18 }}>
                Three things to finish this week
              </div>
            </div>
            <Link to="/team" className="btn btn-line" style={{ fontSize: 12, padding: "8px 14px" }}>
              Manage team →
            </Link>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {openTasks.map((t) => (
              <div
                key={t.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  padding: "10px 14px",
                  background: "var(--paper)",
                  borderRadius: 10,
                }}
              >
                <div
                  style={{
                    width: 22,
                    height: 22,
                    borderRadius: "50%",
                    border: "1.5px solid var(--line-2)",
                    flexShrink: 0,
                  }}
                />
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 500, fontSize: 14 }}>{t.title}</div>
                  {t.description && (
                    <div style={{ fontSize: 12, color: "var(--ink-4)" }}>{t.description}</div>
                  )}
                </div>
                <button
                  className="btn btn-ghost"
                  style={{ padding: "6px 12px", fontSize: 12 }}
                  onClick={() => setupTasksApi.set(t.key, true).then(() => location.reload())}
                >
                  Mark done
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="annotation">
        <span className="annot-label">Coming up:</span>
        Invoicing ships in week 3 — we'll wire customers, the 4-step invoice flow, PDF
        generation, and WhatsApp delivery. Bank reconciliation in week 4.
      </div>
    </>
  );
}
